import {
    FETCH_CATEGORIES,
    FETCH_CATEGORIES_FAILURE,
    FETCH_CATEGORIES_SUCCESS,

    FETCH_CATEGORY,
    FETCH_CATEGORY_FAILURE,
    FETCH_CATEGORY_SUCCESS,
} from 'store/actions/types';

// Categories
export const fetchCategories = (payload) => {
    return {
        type: FETCH_CATEGORIES,
        payload: payload,
    };
};

export const fetchCategoriesFailure = (payload) => {
    return {
        type: FETCH_CATEGORIES_FAILURE,
        payload: payload,
    };
};

export const fetchCategoriesSuccess = (payload) => {
    return {
        type: FETCH_CATEGORIES_SUCCESS,
        payload: payload,
    };
};

// Category
export const fetchCategory = (payload) => {
    return {
        type: FETCH_CATEGORY,
        payload: payload,
    };
};

export const fetchCategoryAccumulated = (payload) => {
    return {
        type: 'FETCH_CATEGORY_ACCUMULATED',
        payload: {
            id: payload.id,
            resource: 'categories',
            type: FETCH_CATEGORIES,
        },
    };
};

export const fetchCategoryFailure = (payload) => {
    return {
        type: FETCH_CATEGORY_FAILURE,
        payload: payload,
    };
};

export const fetchCategorySuccess = (payload) => {
    return {
        type: FETCH_CATEGORY_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/categories/fetchCategories.js